
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.016.023a.906.906 0 0 0-.91.91v8.17H.936a.906.906 0 0 0-.91.91c0 .506.405.91.91.91h8.17v8.17c0 .506.405.91.91.91a.907.907 0 0 0 .643-.264.878.878 0 0 0 .261-.643v-8.17h8.17a.919.919 0 0 0 .642-.26.886.886 0 0 0 .265-.643.906.906 0 0 0-.91-.91l-8.16-.01V.933a.906.906 0 0 0-.91-.91z"}})])
          )
        }
      }
    